import { Card } from '@repo/shadcn';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import {
    AutoCompleteInput,
    Option,
} from '@components/ui/autocomplete/auto-complete-input';

import { useGetAllOrdersV2Query } from '@/features/slice/order';
import { CreateSalesReturnForm } from '@/modules/sales-return/create-sales-return/schema';
import { toastError } from '@/utils';

import { useCreateSalesReturnContext } from './create-sales-return.context';

export const OrderSelector = () => {
    const { data, isLoading, isFetching } = useGetAllOrdersV2Query({});

    const { setOrderId, orderId, getOrderById } = useCreateSalesReturnContext();
    const { reset, setValue } = useFormContext<CreateSalesReturnForm>();

    const options = data?.data?.map((order) => {
        return {
            label: order.invoice_number || `Order #${order.id}`,
            value: order.id,
        };
    });

    const handleSelectOrder = (option: Option) => {
        if (!option.value) {
            reset();
        }
        setOrderId(option.value);
    };

    useEffect(() => {
        if (orderId) {
            getOrderById(orderId)
                .then((response) => {
                    reset();
                    console.log(
                        'OrderSelector: Selected Order Data:',
                        response,
                    );
                    setValue(
                        'items',

                        response?.data?.data?.items?.map((item) => {
                            return {
                                itemId: item.id,
                                itemName: item.product_name,
                                quantity: item.quantity,
                                price: item.price,
                                returnQuantity: item.quantity,
                                rate: item.price,
                                isSelected: false,
                            };
                        }) || [],
                    );

                    setValue('reason', '');
                })
                .catch((error) => toastError(error, 'OrderSelector:useEffect'));
        }
    }, [orderId]);

    return (
        <Card className={'flex items-center gap-4 p-4'}>
            <h2 className={'text-lg font-medium'}>Select Order: </h2>
            <div className={'grow'}>
                <AutoCompleteInput
                    options={options ?? []}
                    emptyMessage={'No orders found'}
                    placeholder={'Select Order'}
                    isLoading={isLoading || isFetching}
                    onValueChange={handleSelectOrder}
                />
            </div>
        </Card>
    );
};
